import React from 'react';
import Head from 'next/head';
import SubLandingPage from 'containers/Join/Duo';
import config from 'config.json';
import { useTranslation } from 'data/translation/useTranslation';
import { useRouter } from 'next/router';
import { CommonPageProps } from 'pages/_app';
import { generateFullPath } from 'lib/url';

const Index = (props: CommonPageProps) => {
  const router = useRouter();
  const { t, locale } = useTranslation();
  const { isLoaded } = props;
  const openGraphImage = generateFullPath('/img/og/duo/open-graph-duo-3.png');

  return (
    <>
      <Head>
        <meta
          name="description"
          content={t('sub_landing_page.two_accounts_living_together')}
        />
        <meta property="fb:app_id" content={config.facebookAppId} />
        <meta
          property="og:title"
          content={t('sub_landing_page.invited_to_join', {
            spotify_premium_duo: t('spotify_premium_duo'),
          })}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://www.spotify.com/${locale}${router.asPath}`}
        />
        <meta property="og:image" content={openGraphImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:secure_url" content={openGraphImage} />
        <meta
          property="og:description"
          content={t('sub_landing_page.two_accounts_living_together')}
        />
      </Head>
      {isLoaded && <SubLandingPage />}
    </>
  );
};

export default Index;
